import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const ExchangeActionsEdit = ({ exchange, company, t, handleClick = () => {} }) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={`/companies/${company.id}/exchange/${exchange.id}/edit`}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(ExchangeActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/list/actions/ExchangeActionEdit.js